var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLearnmodule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.49975C9 4.125 7.875 3 6.50025 3H1.5V12H6.531C9 12 9 14.5005 9 14.5005M9 5.49975C9 4.12425 10.125 3 11.4998 3H16.5V12H11.4998C9 12 9 14.5005 9 14.5005M9 5.49975V14.5005M10.4062 15.3435C10.5627 15.0194 10.8065 14.7454 11.1102 14.5522C11.4139 14.359 11.7654 14.2544 12.1252 14.25H15.75M7.59375 15.3435C7.44012 15.0172 7.19702 14.7412 6.89271 14.5476C6.58841 14.3541 6.2354 14.2509 5.87475 14.25H2.25",
    stroke: "#3F3F3F",
    strokeWidth: 1.125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnmodule);
export default __webpack_public_path__ + "static/media/learnmodule.09e6a86566e822f50b513f80c9002408.svg";
export { ForwardRef as ReactComponent };